import { TRACK_REMAP_SCRIPT_URL } from './trackRemapVendor';

type MyNazcaLoadConfig = {
  /** 読み込み URL（未指定時は /vendor/track-remap） */
  scriptUrl?: string;
  /** <script> の id。二重読み込み防止 */
  scriptId?: string;
};

declare global {
  interface Window {
    TrackRemap?: unknown;
  }
}

const DEFAULT_SCRIPT_ID = 'vendor-track-remap';
const DEFAULT_SCRIPT_URL = TRACK_REMAP_SCRIPT_URL;

function loadScriptOnce(scriptId: string, src: string): Promise<void> {
  if (typeof document === 'undefined') return Promise.reject(new Error('document is not available'));

  const existing = document.getElementById(scriptId) as HTMLScriptElement | null;
  if (existing) {
    // 既に読み込み済み（または読み込み中）なら、それを待つ。
    // data-loaded がない場合も onload/onerror が付いている可能性があるため、状態で分岐する。
    if (existing.dataset.loaded === 'true') return Promise.resolve();
    return new Promise((resolve, reject) => {
      existing.addEventListener('load', () => resolve(), { once: true });
      existing.addEventListener('error', () => reject(new Error(`Failed to load ${src}`)), { once: true });
    });
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.id = scriptId;
    script.src = src;
    script.async = true;
    if (new URL(src, window.location.href).origin !== window.location.origin) {
      script.crossOrigin = 'anonymous';
    }
    script.addEventListener(
      'load',
      () => {
        script.dataset.loaded = 'true';
        resolve();
      },
      { once: true },
    );
    script.addEventListener(
      'error',
      () => {
        reject(new Error(`Failed to load ${src}`));
      },
      { once: true },
    );
    document.head.appendChild(script);
  });
}

export async function loadMyNazca(config: MyNazcaLoadConfig = {}): Promise<void> {
  const scriptId = config.scriptId ?? DEFAULT_SCRIPT_ID;
  const scriptUrl = config.scriptUrl ?? DEFAULT_SCRIPT_URL;

  await loadScriptOnce(scriptId, scriptUrl);

  if (typeof window === 'undefined' || window.TrackRemap == null) {
    throw new Error('TrackRemap is not available on window after loading the script');
  }
}

